module.exports = __webpack_public_path__ + "static/media/Artboard10.ebb46ff1.png";